import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { factory } from "../../api/apiFactory";
import extandDayjs from "../../helpers/dayjs";
import { showNotification } from "./notificationSlice";

const remotelyExtraApi = factory.get("remotely_extra");

const initialState = {
  remotely_extra: {
    loading: false,
    dialog: false,
    form: {
      id: "",
      start_date: dayjs().format("YYYY-MM-DD"),
      end_date: dayjs().format("YYYY-MM-DD"),
      reason: "",
      note: "",
      status_id: 0,
      user_id: null,
    },
  },
  remotely_extras: {
    loading: false,
    data: [],
    total: 0,
    filters: {
      skip: 0,
      take: 50,
      page: 0,
      user_id: "",
      start_date: null,
      end_date: null,
      status_id: "",
    },
  },
};

export const remotelyExtraSlice = createSlice({
  name: "remotelyExtra",
  initialState,
  reducers: {
    setDialog: (state, action) => {
      state.remotely_extra.dialog = !state.remotely_extra.dialog;
      state.remotely_extra.form.id = action.payload ? action.payload : "";
    },
    setDataTable: (state, { payload }) => {
      state.remotely_extras.data = payload.data.data;
      state.remotely_extras.total = payload.data.total;
    },
    setById: (state, { payload }) => {
      state.remotely_extra.form = {
        ...state.remotely_extra.form,
        ...payload,
        id: payload.id,
        start_date: payload.start_date
          ? dayjs(payload.start_date).format("YYYY-MM-DD")
          : dayjs().format("YYYY-MM-DD"),
        end_date: payload.end_date
          ? dayjs(payload.end_date).format("YYYY-MM-DD")
          : dayjs().format("YYYY-MM-DD"),
        reason: payload.reason || "",
        note: payload.note || "",
        status_id:
          payload.status_id !== null && payload.status_id !== undefined
            ? payload.status_id
            : 0,
      };
    },
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    setFilters: (state, { payload }) => {
      state.remotely_extras.filters = {
        ...state.remotely_extras.filters,
        ...payload,
      };
    },
    resetForm: (state) => {
      state.remotely_extra.form = initialState.remotely_extra.form;
    },
    resetFilters: (state) => {
      state.remotely_extras.filters = initialState.remotely_extras.filters;
    },
  },
});

export const {
  setDialog,
  setDataTable,
  setById,
  setLoading,
  setFilters,
  resetForm,
  resetFilters,
} = remotelyExtraSlice.actions;

export default remotelyExtraSlice.reducer;

const getAll = () => async (dispatch, getState) => {
  try {
    const filters = getState().remotelyExtra.remotely_extras.filters;

    dispatch(setLoading("remotely_extras"));
    const res = await remotelyExtraApi.getAll(filters);
    dispatch(setDataTable(res));
    dispatch(setLoading("remotely_extras"));
  } catch (err) {
    dispatch(setLoading("remotely_extras"));
    throw new Error(err);
  }
};

const getById = (id) => async (dispatch) => {
  try {
    dispatch(setLoading("remotely_extra"));
    const res = await remotelyExtraApi.getById(id);
    dispatch(setById(res.data.data[0]));
    dispatch(setLoading("remotely_extra"));
  } catch (err) {
    dispatch(setLoading("remotely_extra"));
    throw new Error(err);
  }
};

const create = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("remotely_extra"));
    await remotelyExtraApi.create({
      start_date: dayjs(data.start_date).format("YYYY-MM-DD"),
      end_date: dayjs(data.end_date).format("YYYY-MM-DD"),
      reason: data.reason || null,
    });
    dispatch(setDialog());
    dispatch(resetForm());
    dispatch(getAll());
    dispatch(
      showNotification({
        message: "تم ارسال طلب الدوام اونلاين بنجاح",
        type: "success",
      }),
    );
    dispatch(setLoading("remotely_extra"));
  } catch (err) {
    dispatch(setLoading("remotely_extra"));
    dispatch(
      showNotification({
        message:
          err?.response?.data?.errors?.[0] || "حدث خطأ أثناء ارسال الطلب",
        type: "error",
      }),
    );
    throw new Error(err);
  }
};

const update = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("remotely_extra"));
    await remotelyExtraApi.update(data.id, {
      start_date: dayjs(data.start_date).format("YYYY-MM-DD"),
      end_date: dayjs(data.end_date).format("YYYY-MM-DD"),
      note: data.note || "",
      status_id: data.status_id,
    });

    dispatch(setDialog());
    dispatch(resetForm());
    dispatch(getAll());
    dispatch(
      showNotification({
        message: "تم تحديث الطلب بنجاح",
        type: "success",
      }),
    );
    dispatch(setLoading("remotely_extra"));
  } catch (err) {
    dispatch(setLoading("remotely_extra"));
    dispatch(
      showNotification({
        message:
          err?.response?.data?.errors?.[0] || "حدث خطأ أثناء تحديث الطلب",
        type: "error",
      }),
    );
  }
};

export const remotelyExtraActions = {
  getAll,
  getById,
  create,
  update,
};
